
function PrivacyPolicyPage() {
  return (
    <>
        {/* Page Title */}
        <h1 
          className="text-4xl font-bold text-center mb-12 text-black" 
          style={{ fontFamily: 'Poppins, sans-serif' }}
        >
          Privacy Policy
        </h1>

        {/* Privacy Policy Content */}
        <div className="prose prose-lg max-w-none text-gray-800">
          <p>
            Your privacy is important to us. It is our policy to respect your privacy regarding any information we may collect from you across our website and other sites we own and operate.
          </p>
          
          <p>
            We only ask for personal information when we truly need it to provide a service to you. We collect it by fair and lawful means, with your knowledge and consent. We also let you know why we're collecting it and how it will be used.
          </p>
          
          <p>
            We only retain collected information for as long as necessary to provide you with your requested service. What data we store, we'll protect within commercially acceptable means to prevent loss and theft, as well as unauthorised access, disclosure, copying, use or modification.
          </p>
          
          <p>
            We don't share any personally identifying information publicly or with third-parties, except when required to by law.
          </p>

          <h2 className="text-2xl font-bold mb-4 text-indigo-900 mt-8">Mobile Information</h2>
          
          <p>
            Your mobile information will not be sold or shared with third parties for promotional or marketing purposes. Any mobile phone numbers, SMS messages, or related mobile data collected through our services will be used solely for the purpose of providing the service you requested and will be handled with the same level of protection as all other personal information.
          </p>

          <h2 className="text-2xl font-bold mb-4 text-indigo-900 mt-8">External Sites</h2>
          
          <p>
            Our website may link to external sites that are not operated by us. Please be aware that we have no control over the content and practices of these sites, and cannot accept responsibility or liability for their respective privacy policies.
          </p>

          <h2 className="text-2xl font-bold mb-4 text-indigo-900 mt-8">Your Rights</h2>
          
          <p>
            You are free to refuse our request for your personal information, with the understanding that we may be unable to provide you with some of your desired services.
          </p>
          
          <p>
            Your continued use of our website will be regarded as acceptance of our practices around privacy and personal information. If you have any questions about how we handle user data and personal information, feel free to contact us.
          </p>
          
          <p className="mt-12 text-gray-600 text-center">
            <strong>This policy is effective as of March 13, 2025.</strong>
          </p>
        </div>
    </>
  );
}

export default PrivacyPolicyPage;